import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { TenantData } from '../../../@core/interfaces/masters/tenant';
import { environment } from '../../../../environments/environment';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-otp-verify-dialog',
  templateUrl: './otp-verify-dialog.component.html',
  styleUrls: ['./otp-verify-dialog.component.css']
})
export class OtpVerifyDialogComponent implements OnInit {

  otpForm: FormGroup;
  @Input() phoneNum: string;
  @Input() tenantId: string;
  @Input() otpId: string;
  @Input() sendthroughsms: boolean;
  @Input() templateData:any;
  @Input() smscontent:string;
  @Input() branchID:string;
  @ViewChild("digit1") d1Element: ElementRef;
  @ViewChild("digit2") d2Element: ElementRef;
  @ViewChild("digit3") d3Element: ElementRef;
  @ViewChild("digit4") d4Element: ElementRef;
  @ViewChild("digit5") d5Element: ElementRef;
  @ViewChild("digit6") d6Element: ElementRef;
  @ViewChild("verifybtn") verifyBtnElement: ElementRef;
  //branchId:string;
  @Output() diaClose: EventEmitter<any> = new EventEmitter<any>();
  protected readonly unsubscribe$ = new Subject<void>();
  otpVerficationResponse: any;
  otpVerification: any;
  isSuccess: boolean = false;
  isFailure: boolean = false;

  // To declare sms_dto to set values written by Abirami Paramasivam / 24.05.21
  smsdto = { "variables": [], "template_id": "", "to": "", "service": "T" };
  branchName: string;
  tenantUserId: any;
  fromPage: string;
  get apiUrl(): string {
    return environment.apiUrl;
  }



  constructor(private routers: Router,protected rolesService: RolesData,public DatService:DateService,protected tenantSrvc: TenantData, private fb: FormBuilder, protected patRegSrvc: PatientRegistrationData) {
    this.otpForm = this.fb.group({
      digit1: this.fb.control('', [Validators.pattern('^[0-9-]+$'), Validators.maxLength(1), Validators.minLength(1)]),
      digit2: this.fb.control(''),
      digit3: this.fb.control(''),
      digit4: this.fb.control(''),
      digit5: this.fb.control(''),
      digit6: this.fb.control(''),
    });
  
    this.otpForm.get("digit1").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d2Element.nativeElement.focus());
    this.otpForm.get("digit2").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d3Element.nativeElement.focus());
    this.otpForm.get("digit3").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d4Element.nativeElement.focus());
    this.otpForm.get("digit4").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d5Element.nativeElement.focus());
    this.otpForm.get("digit5").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d6Element.nativeElement.focus());
    this.otpForm.get("digit6").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.verifyBtnElement.nativeElement.focus());
  }
  get fval() { return this.otpForm.controls; }
  ngOnInit(): void {
    this.fetchTenantBranch();
    if(!!this.d1Element)
    this.d1Element.nativeElement.focus();
  }
  fromTenantRegistration(phoneNum, id, otpId) {
    this.phoneNum = phoneNum;
    this.tenantId = id;
    this.otpId = otpId;
    if(!!this.d1Element)
    this.d1Element.nativeElement.focus();
  }

  fromforgotPassword(fromPage) {
    this.fromPage = fromPage;
    if(!!this.d1Element)
    this.d1Element.nativeElement.focus();
  }

  fromPatientPortal(phoneNum, id, otpId, frompage) {
    this.phoneNum = phoneNum;
    this.tenantId = id;
    this.otpId = otpId;
    this.fromPage = frompage;
    if(!!this.d1Element)
    this.d1Element.nativeElement.focus();
  }
  resendotp() {
    let data = {
      "headers": {
        "Accept": "application/vnd.ezovion.hateoas+json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    }
    this.otpId="";
    this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${this.tenantId}/sendotp/${this.phoneNum}`,data).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.otpId = data;
      this.otpVerification = data;
    }, (error) => {
    }, () => {
      if(this.sendthroughsms){
        this.smscontent="";
        this.smscontent="Ezovion employees never ask for OTP. Sharing it with anyone allows unauthorized access to your Ezovion account. Your OTP is " + this.otpId + ". It will be valid for 2 minutes only. Thanks, Ezovion.";
  
        let smstrackingDetails={
          referencefrom:"ezovion otp",
          referencenum:'0',
          dateTime:this.DatService.currentDate(),
          message:this.smscontent,
          mobileNumber:this.phoneNum,
          smsUnit:1,
          senderId:this.templateData.smsgatewaysettingsDet.serviceName,
          status:"ok",
          templateId:this.templateData.commonTemplateMstDet.templateDetId,
          createdIp:null,
          createdby:parseInt(localStorage.getItem("userId")),
          createddate:this.DatService.currentDate(),
          tenantId:this.tenantId,
          branchId:this.branchID
        }
    
        let smsContent={
          text:this.smscontent,
          mobile:this.phoneNum,
          apiURL:this.templateData.smsgatewaysettingsDet.providerUrl,
          apiKey:this.templateData.smsgatewaysettingsDet.providerKey,
          route:this.templateData.smsgatewaysettingsDet.serviceType,
          senderId:this.templateData.smsgatewaysettingsDet.serviceName,
          tenantId:this.tenantId,
          branchId:this.branchID,
          smstrackingDetails:smstrackingDetails
        }
        this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${this.tenantId}/sendSMS`, smsContent).subscribe(data => {
        }, (error) => {
        }, () => {
        });
      }
    });

    // if (this.fromPage == "PatientPortal" ||this.fromPage == "forgotPassword" ) {

    //   this.patRegSrvc.sendMessageOtp("patientportalnewuser/" + this.tenantId + '/sendotp/' + this.phoneNum, this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    //     this.otpVerification = data;
    //     this.otpId = data;
    //   }, (error) => {
    //   }, () => {
    //   });
    // }
    // else {
    //   this.patRegSrvc.sendMessageOtp("communication/" + this.tenantId + '/' + this.tenantId + '/sendotp/' + this.phoneNum, this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    //     this.otpVerification = data;
    //     this.otpId = data;
    //   }, (error) => {
    //   }, () => {
    //   });
    // }

   
  }
  onVerify() {

    let otp = "";
    otp += this.otpForm.get('digit1').value;
    otp += this.otpForm.get('digit2').value;
    otp += this.otpForm.get('digit3').value;
    otp += this.otpForm.get('digit4').value;
    otp += this.otpForm.get('digit5').value;
    otp += this.otpForm.get('digit6').value;
  
    if (otp !== "") {
      if (otp === this.otpId) {
        this.isSuccess = true;
        this.isFailure = false;
        this.diaClose.emit({ otpStatus: "approved" });
  
        if (this.fromPage !== "PatientPortal" && this.fromPage !== "forgotPassword") {
          this.sendsms();
        }
      } else {
        this.isFailure = true;
        this.isSuccess = false;
      }
  
      this.otpForm.reset();
    }
  }
  onCancel() {

    this.diaClose.emit(null);
  }
  fetchTenantBranch(): void {
      this.tenantSrvc.getById(`${this.apiUrl}/patientportalnewuser/${this.tenantId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

        this.branchName = data.name;
        this.tenantUserId = data.tenantUserId;
      }, (error) => {

      }, () => {
      });
      }

  // To implement sms send function written by Abirami Paramasivam / 24.05.21
  sendsms() {
    this.fetchTenantBranch();
    // To set template variables and template id for to send sms using these template id written by Abirami Paramasivam / 24.05.21
    //  this.sms_dto.variables=[this.branchName,this.tenantUserId];
    this.smsdto.variables = [this.branchName];
    this.smsdto.template_id = "238f0995-b840-4a61-a832-7bf7cd224d9c";
    // To call server side api for sms sending written by Abirami Paramasivam / 24.05.21
    this.patRegSrvc.sendgreetingsMessage("communication/" + this.tenantId + '/' + this.tenantId + '/send_greetings_message/' + this.phoneNum, this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    }, (error) => {
    }, () => {
    });
  }




}
